import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@twioku/common_components";
import { Path } from "../routes/PagePath";
import TwiokuLogoImg from "../assets/twioku_logo_icon.svg";

export const StoryInfoPage: React.FC = () => {
    const navigate = useNavigate();

    const handleViewStories = () => {
        window.open(process.env.VITE_STORY_URL, "_blank");
    };

    return (
        <div>
            <section className="flex flex-col items-center px-4 py-8 mb-12">
                <h2 className="mb-2 w-full text-left text-md underline text-gray-700">
                    みんなのツイオクストーリーとは?
                </h2>
                <p className="mb-6 w-full text-left text-sm leading-relaxed text-gray-700">
                    みんなのツイオクストーリーではツイオクをつうじて得た感動を書き残して置くことができます。
                    <br />
                    ぜひ、ツイオクをつうじて得た感動をツイオクに共感してくれる方々に共有してみてください。
                </p>
                <Button
                    className="w-full max-w-xs rounded-full bg-primary px-6 py-2 text-lg font-medium text-white"
                    onClick={() => navigate(Path.postStory)}
                >
                    ストーリーを残してみる
                </Button>
            </section>
            <div className="px-4 pb-8">
                <button
                    onClick={handleViewStories}
                    className="flex w-full justify-center items-center border border-gray-300 bg-white px-10 py-3 shadow-md"
                >
                    <div className="flex items-center">
                        <img
                            src={TwiokuLogoImg}
                            alt="TwiokuLogoImg"
                            className="mr-3"
                        />
                        <span className="text-gray-700 font-bold text-center">
                            ツイオクストーリーを
                            <br />
                            見てみる
                        </span>
                    </div>
                </button>
            </div>
        </div>
    );
};
